import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SubdomainService {
  readonly #document = inject(DOCUMENT);

  public getSubdomain(): string | null {
    const hostname = this.#document.location.hostname;
    // console.log('# getSubdomain :: hostname: ', hostname);
    const parts = hostname.split('.');

    // Prod:  app.smallsalon.io             → ["app", "smallsalon", "io"]        → no subdomain
    // Prod:  harry.app.smallsalon.io       → ["harry", "app", "smallsalon", "io"] → "harry"
    // Dev:   app.dev.smallsalon.io         → ["app", "dev", "smallsalon", "io"] → no subdomain
    // Dev:   harry.app.dev.smallsalon.io   → ["harry", "app", "dev", "smallsalon", "io"] → "harry"
    // Local: localhost                     → no subdomain
    const appIndex = parts.indexOf('app');
    // console.log('# getSubdomain :: appIndex: ', appIndex);

    if (appIndex > 0) {
      // console.log('# getSubdomain :: return: ', parts[appIndex - 1]);
      return parts[appIndex - 1];
    }

    // console.log('# getSubdomain :: return null');
    return null;
  }
}
